import colors from 'theme/colors';
import breakpoints from 'theme/breakpoints';
import sizes from 'theme/sizes';

const mediaQueries = {
  phone: `@media (min-width: 0px) and (max-width: ${breakpoints.sm})`,
  tablet: `@media (min-width: ${breakpoints.sm}) and (max-width: ${breakpoints.md})`,
  laptop: `@media (min-width: ${breakpoints.md}) and (max-width: ${breakpoints.lg})`,
  desktop: `@media (min-width: ${breakpoints.lg})`,
};

const fonts = {
  h1: {
    fontWeight: 600,
  },
  h2: {
    // Example media query
    // [mediaQueries.phone]: {
    // },
  },
  p: {
    color: colors.fontBody,
  },
  input: {
    color: colors.fontBody,
  },
};

// Build theme object
const theme = {
  primary: {
    mediaQueries,
    colors,
    sizes,
    fonts,
  },
};

// Note: Dynamically builds out TS interface in order to assist
// with intellisense autocompletion and poor field referencing
export interface IThemeProps {
  theme: {
    primary: {
      mediaQueries: typeof theme.primary.mediaQueries;
      colors: typeof theme.primary.colors;
      sizes: {
        fonts: typeof theme.primary.sizes.fonts;
        misc: typeof theme.primary.sizes.misc;
      };
      fonts: typeof theme.primary.fonts;
    };
  };
}

export default theme;
